/* build 2026-08-15 20:55:03 */
/* =========================================================================
   WWC CRO-concept — meelopende koopbalk

   Uitgangspunt: deze balk voegt NIETS zelf toe aan de winkelwagen. Hij zoekt
   de knop die de pagina toch al gebruikt en klikt die aan. Daardoor blijft
   alles werken wat aan die knop hangt — personalisatie, bundelregels,
   variantlogica — en blijft het werken als zo'n app verdwijnt.

   De balk spiegelt ook de TEKST van die knop. Op deze shop verandert de
   koopknop namelijk van betekenis: kiest de bezoeker "Personaliseren", dan
   wordt het "Personaliseren →" en opent hij de configurator in plaats van te
   kopen. Een balk die dan "In winkelwagen" blijft roepen, liegt.

   Uitschakelen: snippets/wwc-cro-config.liquid → cro_sticky_atc = false
   ========================================================================= */

(function () {
  'use strict';

  var CFG = window.WWC_CRO || {};
  if (!CFG.stickyAtc || CFG.template !== 'product') return;

  var bar, ctaBtn, priceOut;
  var buyBox = null;
  var busy = false;
  var io = null;

  /* --- Teksten van de meelopende koopbalk --------------------------------
     Dit stond hardgecodeerd in het Nederlands, terwijl deze balk in de praktijk
     DE koopknop is: de echte knop staat op een mobiele productpagina ver onder
     de vouw. Op /en las een bezoeker dus "In winkelwagen" als laatste tekst
     vóór zijn klik.

     Zelfde opzet als wwc-cro-delivery.js:39-44 - hier en niet in de
     locale-bestanden, want het thema heeft geen sleutels hiervoor en een
     ontbrekende sleutel rendert letterlijk "Translation missing: ...".
     Buiten nl/de/fr valt alles terug op Engels. */
  var STRINGS = {
    nl: { buy: 'In winkelwagen', choose: 'Maak je keuze',    soldOut: 'Uitverkocht' },
    en: { buy: 'Add to cart',    choose: 'Make your choice', soldOut: 'Sold out' },
    de: { buy: 'In den Warenkorb', choose: 'Bitte wählen',   soldOut: 'Ausverkauft' },
    fr: { buy: 'Ajouter au panier', choose: 'Faites votre choix', soldOut: 'Épuisé' }
  };

  var croLang = String(CFG.locale || document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var TXT = STRINGS[croLang] || STRINGS.en;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function visible(el) { return !!(el && el.offsetParent !== null); }

  /* De echte koopknop. De eigen keuzekaart-CTA staat vóór de Motion-knop:
     die laatste is op dit thema verborgen en wordt door de eerste aangestuurd.
     Elke aanroep zoekt opnieuw, zodat een herrenderde koopbox geen dode
     verwijzing achterlaat. */
  function getRealCta() {
    var sels = ['.cz-choice__cta', '[data-add-to-cart]',
                'form[action*="/cart/add"] button[type="submit"]',
                'form[action*="/cart/add"] [name="add"]'];
    for (var i = 0; i < sels.length; i++) {
      var el = $(sels[i]);
      if (el && (visible(el) || sels[i] === '[data-add-to-cart]')) return el;
    }
    return null;
  }

  function getBuyBox() {
    var cta = getRealCta();
    if (!cta) return null;
    return cta.closest('.cz-choice') || cta.closest('.product-block') ||
           cta.closest('form[action*="/cart/add"]') || cta.parentElement;
  }

  /* Staat er een schermvullende configurator open? Die komt als iframe van
     api.woodwidecities.com en dekt de hele viewport. De balk moet daar niet
     overheen liggen — hij hoort bij de productpagina, niet bij de studio. */
  function overlayOpen() {
    var frames = document.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      if (!visible(f)) continue;
      if (!/configurator|\/studio|personalis/i.test(f.src || '')) continue;
      var r = f.getBoundingClientRect();
      if (r.height >= window.innerHeight * 0.8 && r.width >= window.innerWidth * 0.8) return true;
    }
    return false;
  }

  /* Verplichte keuze die nog openstaat. Generiek: elk zichtbaar verplicht
     veld binnen de productsectie dat leeg is. Dat dekt personalisatie-apps
     zonder ze bij naam te kennen. */
  function pendingField() {
    var scope = $('[data-section-type="product"]') || document;
    var fields = scope.querySelectorAll('input[required], select[required], textarea[required]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (!visible(f)) continue;
      if (f.type === 'checkbox' || f.type === 'radio') {
        var group = scope.querySelectorAll('[name="' + CSS.escape(f.name) + '"]');
        var checked = false;
        for (var j = 0; j < group.length; j++) { if (group[j].checked) { checked = true; break; } }
        if (!checked) return f;
      } else if (!String(f.value || '').trim()) {
        return f;
      }
    }
    return null;
  }

  function soldOut() {
    var cta = getRealCta();
    return !!(cta && (cta.disabled || cta.getAttribute('aria-disabled') === 'true'));
  }

  /* Prijs spiegelen uit de pagina zelf. Nooit zelf rekenen: dan kan de balk
     niet afwijken van wat de bezoeker in de koopbox ziet. */
  function syncPrice() {
    var src = $('[data-product-price]');
    if (!src || !priceOut) return;
    var html = src.textContent.trim();
    var cmp = $('[data-compare-price]');
    if (cmp && cmp.textContent.trim() && visible(cmp)) {
      html += '<del>' + cmp.textContent.trim() + '</del>';
    }
    if (priceOut.innerHTML !== html) priceOut.innerHTML = html;
  }

  /* Label spiegelen. De echte knop bepaalt wat er staat; alleen als die niets
     bruikbaars zegt, valt de balk terug op een eigen tekst. */
  function ctaLabel() {
    var cta = getRealCta();
    var t = cta ? (cta.innerText || cta.value || '').replace(/\s+/g, ' ').trim() : '';
    if (t.length > 1 && t.length < 40) return t;
    return TXT.buy;
  }

  function setMode() {
    if (!bar || !ctaBtn) return;

    if (soldOut()) {
      bar.setAttribute('data-mode', 'soldout');
      ctaBtn.textContent = TXT.soldOut;
      ctaBtn.disabled = true;
      return;
    }

    ctaBtn.disabled = false;
    if (pendingField()) {
      bar.setAttribute('data-mode', 'choose');
      ctaBtn.textContent = TXT.choose;
    } else {
      bar.setAttribute('data-mode', 'buy');
      ctaBtn.textContent = ctaLabel();
    }
  }

  function show(on) {
    if (!bar) return;
    if (on && overlayOpen()) on = false;
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.body.classList.toggle('wwc-sticky-buy-active', on);
  }

  var lastShouldShow = false;
  function refresh() { show(lastShouldShow); }

  function jumpToBuyBox(focusEl) {
    var target = getBuyBox();
    if (!target) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 90,
                      behavior: reduce ? 'auto' : 'smooth' });
    target.classList.remove('wwc-cro-pulse');
    void target.offsetWidth;
    target.classList.add('wwc-cro-pulse');
    window.setTimeout(function () {
      target.classList.remove('wwc-cro-pulse');
      if (focusEl && typeof focusEl.focus === 'function') {
        try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); }
      }
    }, reduce ? 0 : 700);
  }

  function onCtaClick(e) {
    e.preventDefault();
    if (busy) return;

    var pending = pendingField();
    if (pending) { jumpToBuyBox(pending); return; }

    var cta = getRealCta();
    if (!cta) { jumpToBuyBox(null); return; }

    busy = true;
    ctaBtn.classList.add('is-busy');
    /* Vlag rond de synthetische klik. cta.click() stuurt een ECHTE bubbelende
       klik, en de gedelegeerde handler in wwc-cro-track.js kan die niet van een
       muisklik onderscheiden - dus telde elke aankoop via deze balk twee keer,
       als wwc_sticky_buy EN als wwc_buy_click. Daardoor was het aandeel "via de
       balk" niet te berekenen en was het totaal aantal koopklikken opgeblazen. */
    window.__wwcSyntheticCta = true;
    cta.click();
    window.setTimeout(function () { window.__wwcSyntheticCta = false; }, 0);

    // Geen betrouwbaar "klaar"-signaal van thema of app; korte vergrendeling
    // voorkomt dubbel toevoegen. Daarna opnieuw kijken of er inmiddels een
    // overlay openstaat (configurator) — dan hoort de balk weg.
    window.setTimeout(function () {
      busy = false;
      ctaBtn.classList.remove('is-busy');
      setMode();
      refresh();
    }, 1200);
  }

  function init() {
    bar = $('[data-wwc-sticky-buy]');
    if (!bar) return;

    ctaBtn = $('[data-wwc-sticky-cta]', bar);
    priceOut = $('[data-wwc-sticky-price]', bar);
    buyBox = getBuyBox();
    if (!buyBox) return;

    bar.hidden = false;
    syncPrice();
    setMode();
    ctaBtn.addEventListener('click', onCtaClick);

    if ('IntersectionObserver' in window) {
      /* io buiten dit blok houden, zodat de MutationObserver hieronder hem
         opnieuw kan aanhaken als de koopbox vervangen wordt. */
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          lastShouldShow = !entry.isIntersecting;
          refresh();
        });
      }, { rootMargin: '-80px 0px -20px 0px', threshold: 0 });
      io.observe(buyBox);
    } else {
      window.addEventListener('scroll', function () {
        var r = buyBox.getBoundingClientRect();
        lastShouldShow = (r.bottom < 80 || r.top > window.innerHeight);
        refresh();
      }, { passive: true });
    }

    /* De koopbox wordt door apps herrenderd, dus kijken we naar de sectie in
       plaats van naar losse elementen. Dit vangt ook het openen en sluiten
       van de configurator op. */
    var scope = $('[data-section-type="product"]');
    if (scope && 'MutationObserver' in window) {
      new MutationObserver(function () {
        syncPrice();
        setMode();
        refresh();
        /* HERBINDEN. Hier werd alleen de variabele bijgewerkt, terwijl de
           IntersectionObserver aan het OUDE element bleef hangen. Vervangt de
           configurator-app de koopbox - en de code hier gaat daar zelf van uit -
           dan keek de observer naar een element dat niet meer in de pagina zit.
           Gevolg: de balk bleef staan of kwam nooit tevoorschijn. */
        var fresh = getBuyBox();
        if (fresh && fresh !== buyBox) {
          buyBox = fresh;
          if (io) {
            io.disconnect();
            io.observe(buyBox);
            /* Direct opnieuw bepalen, want disconnect() wist de laatste stand
               en zonder scroll komt er geen nieuw signaal. */
            var rr = buyBox.getBoundingClientRect();
            lastShouldShow = (rr.bottom < 80 || rr.top > window.innerHeight);
            refresh();
          }
        }
      }).observe(scope, { childList: true, subtree: true, characterData: true });
    }

    // Een configurator kan buiten de productsectie in de body worden gehangen.
    if ('MutationObserver' in window) {
      new MutationObserver(function () { refresh(); })
        .observe(document.body, { childList: true });
    }

    ['variantChange', 'variant:changed', 'change', 'input'].forEach(function (ev) {
      document.addEventListener(ev, function () { syncPrice(); setMode(); }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* -------------------------------------------------------------------------
   Chips-rij: vervaging aan de rechterrand uitzetten zodra je aan het einde
   bent. Zonder dit blijft er een fade staan waar niets meer achter zit, en
   dat leest als ontbrekende inhoud.

   Bewust geen scroll-gedreven CSS-animatie: die wordt nog niet overal
   ondersteund, en dit is zes regels.
   ------------------------------------------------------------------------- */
(function () {
  function bind(slider) {
    if (!slider || slider.__wwcEndBound) return;
    slider.__wwcEndBound = true;
    function update() {
      var eind = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;
      slider.classList.toggle('is-end', eind);
    }
    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document
      .querySelectorAll('.wwc-manual-city-bubbles .wwc-bubbles__slider')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===========================================================================
   Breadcrumb-bug: bovenruimte valt weg na scrollen

   HET MECHANISME (gemeten, niet aangenomen)
   Motion haalt de header uit de flow zodra je voorbij 250px scrolt
   (klasse site-header--stuck, position: fixed) en vangt de verdwenen hoogte op
   met een placeholder #StickyHeaderWrap die een VASTE pixelhoogte krijgt.

   Die hoogte wordt gemeten in theme.js (stickyHeaderHeight) en die functie
   hangt OOK aan window resize - zonder te controleren of de header op dat
   moment vastgeplakt staat. Op mobiel vuurt resize juist bij het in- en
   uitschuiven van de adresbalk, dus precies bij "naar beneden en weer omhoog".

   En de header is in de twee staten niet even hoog:
       los          72px   (logo 60px breed)
       vastgeplakt  62px   (logo 50px breed)
   De logo-hoogte komt uit een procentuele padding-top die tegen de breedte
   gerekend wordt, dus breedte wijzigen = hoogte wijzigen.

   Gevolg: de placeholder krijgt 62px. Zodra de header weer in de flow komt is
   hij 72px en steekt hij 10px uit zijn eigen placeholder. Omdat .site-header
   position: relative is, tekent hij over de breadcrumb eronder - en lijkt de
   bovenruimte daar verdwenen. Motion hermeet nooit bij het loslaten.

   WAAROM HIER EN NIET IN theme.js
   theme.js is een Motion-vendorbestand; bij een thema-update is elke wijziging
   daar weg. Dit staat los en overleeft dat.
   =========================================================================== */
(function () {
  var header = document.getElementById('SiteHeader');
  var wrap = document.getElementById('StickyHeaderWrap');
  if (!header || !wrap) return;

  var STUCK = 'site-header--stuck';
  var losseHoogte = 0;

  function vastgeplakt() {
    return header.classList.contains(STUCK);
  }

  /* Alleen meten in de LOSSE staat; dat is de enige hoogte die de placeholder
     hoort te reserveren. */
  function meet() {
    if (vastgeplakt()) return;
    var h = header.offsetHeight;
    if (h > 0) losseHoogte = h;
  }

  function herstel() {
    if (!losseHoogte) return;
    if (parseInt(wrap.style.height || '0', 10) === losseHoogte) return;
    wrap.style.height = losseHoogte + 'px';
  }

  meet();

  /* Zodra de header loskomt: eerst de onthouden hoogte terugzetten (Motion kan
     er inmiddels een te kleine waarde in hebben geschreven), dan pas opnieuw
     meten - de layout is op het moment van de klasse-wijziging nog niet bij. */
  new MutationObserver(function () {
    if (vastgeplakt()) return;
    herstel();
    window.requestAnimationFrame(function () {
      meet();
      herstel();
    });
  }).observe(header, { attributes: true, attributeFilter: ['class'] });

  /* Na een resize hermeet Motion met 50ms vertraging. Wij lopen daarachteraan
     en corrigeren als die meting in de vastgeplakte staat gebeurde. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      if (!vastgeplakt()) meet();
      herstel();
    }, 120);
  }, { passive: true });
})();

/* Offertevenster: openen, sluiten, en na een geslaagde inzending meteen weer
   tonen zodat de bevestiging niet onzichtbaar in een gesloten dialog staat.

   Dit was TWEE modules die allebei op dezelfde klik reageerden. De eerste
   opende het venster, de tweede riep showModal() nog eens aan op een al
   geopend venster - dat gooit een InvalidStateError, en daardoor sneuvelde
   alles wat daarna kwam, inclusief de sluitknop. Bovendien stond
   ruimCaptchaOp() per ongeluk binnen het open-blok terwijl hij bij sluiten
   werd aangeroepen. Nu één module. */
(function () {
  function venster() { return document.querySelector('[data-zakelijk]'); }

  /* Shopify's eigen contactformulier laadt hCaptcha. Die zet een overlay met een
     extreem hoge z-index BUITEN onze dialog, en die blijft staan als het venster
     sluit - dan kijk je tegen een onklikbaar scherm aan. */
  function ruimCaptchaOp() {
    document.querySelectorAll(
      'iframe[src*="hcaptcha"], iframe[src*="recaptcha"], .h-captcha, .g-recaptcha'
    ).forEach(function (n) {
      var doos = (n.closest && n.closest('div[style*="z-index"]')) || n;
      if (doos && doos.parentNode && doos !== document.body) doos.parentNode.removeChild(doos);
    });
    document.querySelectorAll('body > div[style*="2000000000"]').forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* Twee openers, één venster.

       [data-zakelijk-open] is de knop naast de prijs. a[href$="#offerte"] is
       erbij gekomen voor de infohub: dat antwoordveld is een Shopify RICHTEXT
       en daar accepteert Shopify alleen <a href> - geen class, geen
       data-attribuut. Zonder deze tak zou de enige manier om vanuit een
       antwoord naar het offerteformulier te wijzen een dode ankerlink zijn. */
    var opener = e.target.closest('[data-zakelijk-open], a[href$="#offerte"]');
    if (opener) {
      var d = venster();
      /* preventDefault ALTIJD bij een anker, ook als het venster ontbreekt:
         anders springt de pagina naar boven op een anker dat nergens heen
         gaat, en dat voelt als een kapotte link. */
      if (opener.tagName === 'A') e.preventDefault();
      /* Al open? Niets doen. showModal() op een geopende dialog gooit. */
      if (!d || d.open) return;
      if (d.showModal) { d.showModal(); } else { d.setAttribute('open', ''); }
      /* Trechterstap 1. Zonder dit getal is elke discussie over de zakelijke
         route giswerk: we weten niet eens hoe vaak iemand hem aanraakt. */
      meet('wwc_offerte_open');
      return;
    }

    if (e.target.closest('[data-zakelijk-sluit]')) {
      var d2 = venster();
      if (!d2) return;
      if (d2.close) { d2.close(); } else { d2.removeAttribute('open'); }
      ruimCaptchaOp();
    }
  }, true);

  /* Escape sluit de dialog zelf; de captcha-overlay moet dan ook weg. */
  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-zakelijk]')) ruimCaptchaOp();
  }, true);

  /* Na een geslaagde inzending staat de bevestiging in de dialog; die moet dus
     open. */
  if (document.querySelector('[data-zakelijk] .wwc-zakelijk__dank')) {
    var d3 = document.querySelector('[data-zakelijk]');
    if (d3 && d3.showModal && !d3.open) d3.showModal();
    /* Trechterstap 2. Shopify stuurt na een geslaagde inzending terug naar
       dezelfde pagina met de bevestiging erin; dat is het enige moment waarop
       we zeker weten dat er echt verstuurd is. */
    meet('wwc_offerte_completed');
  }

  /* Eén helper, zodat beide events dezelfde context meesturen. */
  function meet(naam) {
    try {
      window.dataLayer = window.dataLayer || [];
      var pdp = window.WWC_CRO_PDP || {};
      window.dataLayer.push({
        event: naam,
        product_id: pdp.productId || null,
        product_type: pdp.productType || null,
        city: pdp.city || null
      });
    } catch (e) { /* meting mag de pagina nooit breken */ }
  }
})();

/* ===========================================================================
   Maat live bijwerken bij een maatwissel

   De feitenregel en het maatvenster worden server-side gerenderd. Wisselt de
   bezoeker van Afmeting zonder de pagina te herladen, dan bleef daar de OUDE
   maat staan - "80 × 16,5 cm" terwijl er 120 cm gekozen was.

   De hele tabel voor deze soort staat als data-attribuut op de feitenregel;
   hieronder wordt alleen de juiste regel eruit gepakt. Aangehaakt op
   wwc:selection, dezelfde bron als de materiaalkaarten.
   =========================================================================== */
(function () {
  function tabel() {
    var el = document.querySelector('[data-maten]');
    if (!el) return null;
    var ruw = el.getAttribute('data-maten') || '';
    var m = {};
    ruw.split('|').forEach(function (rij) {
      if (!rij) return;
      var i = rij.indexOf(':');
      if (i < 0) return;
      m[rij.slice(0, i)] = rij.slice(i + 1);
    });
    return Object.keys(m).length ? m : null;
  }

  /* De optienaam verschilt per taal. Zelfde lijst als in wwc-selection.js en
     wwc-product.js - houd ze gelijk. */
  var MAAT_NAMEN = ['Afmeting', 'Size', 'Größe', 'Grösse', 'Taille'];

  function maatRadio() {
    for (var i = 0; i < MAAT_NAMEN.length; i++) {
      var r = document.querySelector('input[name="' + MAAT_NAMEN[i] + '"]:checked');
      if (r) return r;
    }
    return null;
  }

  function huidigeBreedte() {
    var k = window.WWC && window.WWC.getSelection ? window.WWC.getSelection() : null;
    if (k && k.sizeNumber) return String(k.sizeNumber);

    /* Hier stond een aanroep van maatRadio() zonder dat die functie in deze
       module bestond: hij was achtergebleven toen het maatvenster eruit ging.
       Gevolg was een ReferenceError bij ELKE aanroep waarbij getSelection geen
       maat teruggaf - dus op klok, plank, onderzetters en magneet, want die
       hebben helemaal geen Afmeting-optie. De fout werd bij elke wwc:selection
       opnieuw gegooid en brak de rest van deze handler af.

       Geen maat gevonden is een geldige uitkomst, geen fout: bijwerken() stopt
       er netjes op. */
    var r = maatRadio();
    if (!r) return null;
    var n = parseFloat(String(r.value).replace(',', '.'));
    return isNaN(n) ? null : String(n);
  }

  function bijwerken() {
    var m = tabel();
    if (!m) return;
    var b = huidigeBreedte();
    if (!b || !m[b]) return;

    document.querySelectorAll('[data-maat-tekst]').forEach(function (el) {
      el.textContent = m[b];
    });
    document.querySelectorAll('.wwc-maatvenster__maat').forEach(function (el) {
      el.textContent = m[b];
    });

    /* Schaalbalk mee: breedte ten opzichte van een bank van 220 cm. */
    var balk = document.querySelector('.wwc-maatschaal__balk--product');
    if (balk) balk.style.width = Math.round(parseFloat(b) / 220 * 100) + '%';

    /* AR-bestand volgt de maat; anders open je een model van de vorige keuze.
       LET OP: de bestandsnamen staan in MILLIMETERS (skyline-1200mm.usdz)
       terwijl de maatkeuze in centimeters is. Vandaar de factor 10 - zonder
       die omrekening bleef hier het model van de vorige maat staan. */
    var mm = Math.round(parseFloat(b) * 10);
    document.querySelectorAll('.wwc-maatvenster__ar-knop').forEach(function (a) {
      ['href', 'data-ar-glb'].forEach(function (attr) {
        var v = a.getAttribute(attr);
        if (v) a.setAttribute(attr, v.replace(/-\d+mm\./, '-' + mm + 'mm.'));
      });
    });
  }

  document.addEventListener('wwc:selection', bijwerken);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bijwerken);
  } else {
    bijwerken();
  }
})();







/* Meting van het maatvenster. Het was als enige onderdeel van het CRO-concept
   ongemeten, waardoor elke discussie erover een smaakdiscussie bleef. */
(function () {
  if (!window.dataLayer) window.dataLayer = [];
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-maatvenster-open]')) {
      var v = document.querySelector('[data-maatvenster]');
      window.dataLayer.push({
        event: 'wwc_maat_open',
        soort: v ? v.getAttribute('data-soort') : '',
        maten: v ? (v.getAttribute('data-maten') || '').split('|').length : 0
      });
    }
    var chip = e.target.closest('[data-mv-ref]');
    if (chip) {
      window.dataLayer.push({ event: 'wwc_maat_referentie', breedte_cm: parseFloat(chip.getAttribute('data-mv-ref')) });
    }
  }, true);
})();

/* ===========================================================================
   Chips-rij op de collectiepagina: Swiper stilzetten en zelf naar de actieve
   chip schuiven.

   WAT ER MIS WAS (gemeten, niet aangenomen)
   De sectie wwc-manual-city-bubbles start een Swiper. Onze chips-modus maakt
   van diezelfde container een native scroller en zet
   `transform: none !important` op de track. Gevolg:

     1. swiper.slideTo() schrijft een transform die door dat !important wordt
        weggegooid. Gemeten: slideNext() veranderde niets - transform bleef
        `none`, scrollLeft bleef 0, terwijl Swipers interne translate wel naar
        -240.7 liep. De balk sprong dus nooit naar de actieve collectie, want
        die sprong werd getekend in een laag die niet meer bestond.

     2. Swiper bleef wel pointer-events afvangen en zette via
        .swiper-pointer-events `touch-action: pan-y` op de rij (zie CSS).

   WAT HIER GEBEURT
   - swiper.disable(): nette publieke API, laat de instantie staan maar stopt
     alle interactie. Gecontroleerd: voegt geen klasse toe, alle chips blijven
     staan, scrollWidth/clientWidth veranderen niet.
   - daarna de actieve chip zelf in beeld schuiven met scrollLeft, wat wel
     werkt op een native scroller.

   De Swiper wordt asynchroon opgestart (waitForSwiper in wwc-collection.js),
   dus we wachten kort tot de instantie er is. Komt hij niet, dan schuiven we
   alsnog naar de actieve chip - dat deel heeft Swiper niet nodig.
   =========================================================================== */
(function () {
  function actieveChip(slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.swiper-slide'));
    var pad = window.location.pathname;
    var i;

    /* Eerst op URL: dat is de waarheid over "waar ben ik". De data-active en
       swiper-slide-active zijn terugvallen - de eerste stond op deze pagina op
       geen enkele slide, de tweede is Swipers eigen idee en dat kan afwijken. */
    for (i = 0; i < slides.length; i++) {
      var a = slides[i].querySelector('a[href]');
      if (a && a.getAttribute('href').split('?')[0] === pad) return slides[i];
    }
    for (i = 0; i < slides.length; i++) {
      if (slides[i].dataset.active === '1') return slides[i];
    }
    return slider.querySelector('.swiper-slide-active');
  }

  function naarActief(slider) {
    if (slider.scrollWidth <= slider.clientWidth + 2) return;
    var chip = actieveChip(slider);
    if (!chip) return;

    var max = slider.scrollWidth - slider.clientWidth;
    var doel = chip.offsetLeft - (slider.clientWidth - chip.offsetWidth) / 2;
    slider.scrollLeft = Math.max(0, Math.min(max, doel));
  }

  function temSwiper(slider) {
    if (slider.__wwcChipsBound) return;
    slider.__wwcChipsBound = true;

    var pogingen = 0;
    var timer = window.setInterval(function () {
      if (slider.swiper) {
        try { slider.swiper.disable(); } catch (e) {}
        window.clearInterval(timer);
        naarActief(slider);
      } else if (++pogingen > 60) {
        window.clearInterval(timer);
        naarActief(slider);
      }
    }, 50);
  }

  function init() {
    if (!document.documentElement.classList.contains('wwc-cro-chips')) return;
    document
      .querySelectorAll('.wwc-manual-city-bubbles .wwc-bubbles__slider')
      .forEach(temSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
